import React from 'react';

import * as Styled from './StyledDashboardArea';

export const DashboardArea = ({ children, graph, title }) => (
    <Styled.DashboardArea>
        {!!title && <Styled.Title>{title}</Styled.Title>}
        <Styled.Area>
            <Styled.Infos>{children}</Styled.Infos>
            {!!graph && <Styled.Graph>{graph}</Styled.Graph>}
        </Styled.Area>
    </Styled.DashboardArea>
);
